import {safePlanIntentDestination} from '../billing/planIntent.js';

const SUPPORTED_PROVIDERS = new Set(['google', 'apple']);
export const NATIVE_AUTH_CALLBACK = 'com.silahub.silatrail://auth/callback';

export function safeAuthReturnTo(value) {
  const planDestination = safePlanIntentDestination(value);
  if (planDestination) return planDestination;
  return typeof value === 'string' &&
    value.startsWith('/accountant/invite/') &&
    !value.startsWith('//')
    ? value
    : '';
}

export function buildOAuthRedirect(origin, returnTo = '') {
  const url = new URL('/login', origin);
  const safeReturnTo = safeAuthReturnTo(returnTo);
  if (safeReturnTo) url.searchParams.set('returnTo', safeReturnTo);
  return url.toString();
}

export function buildNativeOAuthRedirect(returnTo = '') {
  const url = new URL(NATIVE_AUTH_CALLBACK);
  const safeReturnTo = safeAuthReturnTo(returnTo);
  if (safeReturnTo) url.searchParams.set('returnTo', safeReturnTo);
  return url.toString();
}

export function parseNativeOAuthCallback(value) {
  try {
    const url = new URL(value);
    if (
      url.protocol !== 'com.silahub.silatrail:' ||
      url.hostname !== 'auth' ||
      url.pathname !== '/callback'
    ) return null;
    return {
      code: url.searchParams.get('code') || '',
      error: url.searchParams.get('error') || url.searchParams.get('error_description') || '',
      returnTo: safeAuthReturnTo(url.searchParams.get('returnTo'))
    };
  } catch {
    return null;
  }
}

export function enabledSocialProviders(environment = {}) {
  return [
    environment.VITE_GOOGLE_AUTH_ENABLED === 'true' ? 'google' : null,
    environment.VITE_APPLE_AUTH_ENABLED === 'true' ? 'apple' : null
  ].filter(Boolean);
}

export async function signInWithSocialProvider({
  client,
  provider,
  origin,
  returnTo = '',
  callbackMode = 'web'
}) {
  if (!client) throw new Error('Authentication is temporarily unavailable.');
  if (!SUPPORTED_PROVIDERS.has(provider)) throw new Error('Choose a supported sign-in provider.');
  if (callbackMode !== 'web' && callbackMode !== 'native') throw new Error('Choose a supported callback mode.');

  const options = {
    redirectTo: callbackMode === 'native'
      ? buildNativeOAuthRedirect(returnTo)
      : buildOAuthRedirect(origin, returnTo)
  };
  if (callbackMode === 'native') {
    options.skipBrowserRedirect = true;
    if (provider === 'google') options.queryParams = {prompt: 'select_account'};
  }

  const {data, error} = await client.auth.signInWithOAuth({provider, options});
  if (error) throw error;
  return data;
}

export function hasOAuthCallbackError(searchParams) {
  return Boolean(searchParams?.get('error') || searchParams?.get('error_description'));
}
